import lib from "./lib";

const getConfigDataUtils = {
    getDataUrlByDataId: function getDataUrlByDataId(dataId) {
        let mariaUrl = lib.config.mariaUrl || "https://maria-test.yang800.com.cn";
        let config = lib.config.configList.find(item => {
            return item.id === dataId;
        });
        if (config) {
            return `${mariaUrl}/api/data/v2/${dataId}/${config.versionId}`;
        } else {
            return `${mariaUrl}/api/data/v2/${dataId}`;
        }
    },
};
export default getConfigDataUtils;
